import { createSlice } from "@reduxjs/toolkit";

// `loaded` sits inside `effective` so the selector keeps one stable reference
const INITIAL_STATE = {
	effective: { seasons: [], cups: [], loaded: false },
	preferred: { seasons: [], cups: [] },
};

const defaultSelectionsSlice = createSlice({
	name: "defaultSelections",
	initialState: INITIAL_STATE,
	reducers: {
		setDefaultSelections: (state, action) => {
			state.effective = action.payload.effective;
			state.preferred = action.payload.preferred;
		},
		clearDefaultSelections: () => INITIAL_STATE,
	},
});

export const { setDefaultSelections, clearDefaultSelections } = defaultSelectionsSlice.actions;

export const selectDefaultSelections = (state) => state.defaultSelections.effective;
export const selectPreferredSelections = (state) => state.defaultSelections.preferred;

export default defaultSelectionsSlice.reducer;
